// export const HOST_URL = 'http://localhost:8888' //DEV -> 'http://localhost:8888' //PROD -> https://back.bibianadiazweddingplanner.com
// export const HOST_URL_IMGS = 'http://localhost:7000' //DEV -> 'http://localhost:7000' //PROD -> https://back.bibianadiazweddingplanner.com
// export const HOST_URL_BIBI = 'http://localhost:8000' //PROD -> https://bibianadiazweddingplanner.com //DEV -> 'http://localhost:8000' //PREPROD -> https://develop.bibianadiazweddingplanner.com //PROD -> https://bibianadiazweddingplanner.com
export const HOST_URL = 'https://back.bibianadiazweddingplanner.com' //DEV -> 'http://localhost:8888' //PROD -> https://back.bibianadiazweddingplanner.com
export const HOST_URL_IMGS = 'https://back.bibianadiazweddingplanner.com' //DEV -> 'http://localhost:7000' //PROD -> https://back.bibianadiazweddingplanner.com
export const HOST_URL_BIBI = 'https://bibianadiazweddingplanner.com' //PROD -> https://bibianadiazweddingplanner.com //DEV -> 'http://localhost:8000' //PREPROD -> https://develop.bibianadiazweddingplanner.com //PROD -> https://bibianadiazweddingplanner.com


export const VERSION_API = 'api/v1'
export const VALIDAR_ESTATUS = {
  STATUS_100: /(1\D)\w+/g,
  STATUS_200: /(2\D)\w+/g,
  STATUS_300: /(3\D)\w+/g,
  STATUS_400: /(4\D)\w+/g,
  STATUS_500: /(5\D)\w+/g
}
export const INTENTO_CONEXION = 5
export const INFORMACION_MENSAJE_NOTIFICACION = {
  ES_MENSAJE_CLOSE_TRUE: true,
  ES_MENSAJE_CLOSE_FALSE: true,
  TIPO_DE_MENSAJE_EXITOSO: '#2fcd49',
  TIPO_DE_MENSAJE_ERROR: "#ab3939",
  TIPO_DE_MENSAJE_ADVERTENCIA: 'warning',
  COLOR_DE_MENSAJE_PERSONALIZADO_RGB: (colorRgb: any) => colorRgb,
  ICONO_DEL_MENSAJE: (icono: any) => `<i class='mdi ${icono}' ></i>`,
  HEADER_ERROR: `UPS`,
  HEADER_SUCCESS: `OK`,
  HEADER_INFORMATIVO: `CUIDADO!`,
  ICONO_ERROR: 'mdi mdi-close-circle-outline',
  DURACION_3_SEGUNDOS: '3000',
  DURACION_6_SEGUNDOS: '6000',
  DURACION_9_SEGUNDOS: '9000',
  TITULO_ERROR_CONEXION: 'Error De Conexion',
  DESCRIPCION_ERROR_CONEXION_500: 'Ocurrio un Error al conectar porfavor Intenta mas tarde... 🤒',
  TITULO_BAD_REQUEST: 'Error 404 Bad Request',
  DESCRIPCION_BAD_REQUEST_400: 'Ocurrio un Error de peticion Comunicate con el Administrador... ✋',
  TITULO_CONEXION_LOST: 'Caida De Servidor',
  DESCRIPCION_CONEXION_LOST: 'Ocurrio un Error de conexion Porfavor Contacta al Administrador... 😡',
  TITULO_DEFAULT: 'Mensaje Por Defecto',
  DESCRIPCION_DEFAULT: 'Debes Agregar alguna descripcion... 🤯'
}

export async function avifToPngBase64(avifBase64: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('No se pudo obtener el contexto del canvas'));
        return;
      }
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = avifBase64;
  });
}

/**
 * Carga una imagen y la convierte a base64 (MEJORADO - SOPORTA AVIF)
 */
export async function loadImageBase64(path: string): Promise<string> {
  if (!path) return ''
  
  try {
    // Verificar si es AVIF o usar el método de conversión directamente
    const isAvif = path.toLowerCase().endsWith('.avif')
    
    if (isAvif) {
      // Para AVIF, usar la conversión a través de canvas
      return await convertImageToCompatibleFormat(path)
    }
    
    // Para otros formatos, intentar primero el método original
    try {
      const response = await fetch(path)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const blob = await response.blob()
      
      // Si es AVIF detectado por el blob type, convertir
      if (blob.type === 'image/avif') {
        return await convertImageToCompatibleFormat(path)
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = () => reject(new Error('Error reading file'))
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      // Si falla el fetch, intentar con conversión
      console.warn('Fetch falló, intentando conversión directa:', error)
      return await convertImageToCompatibleFormat(path)
    }
  } catch (error) {
    console.error('Error loading image:', path, error)
    throw error
  }
}

/**
 * Convierte una imagen AVIF (o cualquier formato) a base64 en formato compatible con jsPDF
 */
async function convertImageToCompatibleFormat(imageUrl: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    
    img.onload = () => {
      // Crear un canvas
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        reject(new Error('No se pudo obtener el contexto del canvas'))
        return
      }
      
      // Dibujar la imagen en el canvas
      ctx.drawImage(img, 0, 0)
      
      // Convertir a JPEG (mejor para fotos) o PNG (mejor para gráficos)
      // JPEG tiene mejor compresión para fotografías
      const base64 = canvas.toDataURL('image/jpeg', 0.9)
      resolve(base64)
    }
    
    img.onerror = () => {
      reject(new Error(`Error cargando imagen: ${imageUrl}`))
    }
    
    img.src = imageUrl
  })
}

export function getImagePath(path: string) {
  const baseURL = `${HOST_URL_IMGS}/public/imgs/output`
  return path.startsWith('http') ? path : baseURL + '/' + reemplazar_extencion_cualquiera_a_avif(path)
}

function reemplazar_extencion_cualquiera_a_avif(path: string) {
  return path.replace(/\.[^/.]+$/, '.avif')
}